module.exports = __webpack_public_path__ + "img/Avatar-96.8039f526.svg";